import ecologicalIntegritySrc from '@assets/images/page-description/ecological-integrity.png';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_LANDLER_RULEBOOK } from '@/config/constants';
import { Description } from '@/pages/shared/projects/pages/project/pages/conservation/BU/components/PageDescription';

export const EcologicalIntegrityDescription = () => {
  const { t } = useTranslation();
  const EXPLAINERS_LABEL_PATH = 'shared.ncaDetail.details.ecologicalIntegrity.explainers.pageDescription';

  return (
    <Description.Container imageSrc={ecologicalIntegritySrc} imageAlt={t(`${EXPLAINERS_LABEL_PATH}.imageAlt`)}>
      <Description.Title>{t(`${EXPLAINERS_LABEL_PATH}.title`)}</Description.Title>
      <Description.Subtitle>{t(`${EXPLAINERS_LABEL_PATH}.subtitle`)}</Description.Subtitle>
      <Description.Body>{t(`${EXPLAINERS_LABEL_PATH}.body`)}</Description.Body>
      <Description.Link to={METHODOLOGY_LANDLER_RULEBOOK.ECOLOGICAL_INTEGRITY}>
        {t(`${EXPLAINERS_LABEL_PATH}.link`)}
      </Description.Link>
    </Description.Container>
  );
};
